import convertPromiseToQueryReturnValue from '../../../service/shared/convertPromiseToQueryReturnValue';
import UserAPI from '../UserAPI';
import SettingsCalls from './SettingsCalls';
import { SettingsAllAPI } from './UserSettings.model';

export const UserSettingsAPI = UserAPI.injectEndpoints({
  endpoints: (builder) => ({
    getAllSettings: builder.query<SettingsAllAPI, void>({
      query: () => ({
        url: `/settings`,
        method: 'GET',
      }),
      transformResponse: (response: SettingsAllAPI) => response,
      providesTags: ['settings-data'],
    }),
    setSetting: builder.mutation<void, { settingName: string; value: string }>({
      query: ({ settingName, value }) => ({
        url: `/settings/${settingName}`,
        method: 'PUT',
        data: value,
        headers: {
          'Content-Type': 'text/plain',
        },
      }),
      invalidatesTags: ['settings-data'],
    }),
    setManySettings: builder.mutation<
      void,
      { settings: Record<string, string> }
    >({
      async queryFn({ settings }, _api, _extraOptions, baseQuery) {
        const settingCalls = new SettingsCalls();
        const promises = Object.entries(settings).map(
          async ([settingName, value]) => {
            // Get current state value for the setting
            const state: any =
              UserSettingsAPI.endpoints.getAllSettings.select()(
                _api.getState() as any
              );
            const currentValue = state.data?.[settingName];
            // Only update if the value is different
            if (currentValue === value) {
              return Promise.resolve();
            }
            // if the value is false, then delete
            if (!value) {
              return settingCalls.deleteSetting(settingName);
            }
            return settingCalls.setSetting(settingName, value);
          }
        );
        return convertPromiseToQueryReturnValue<void>(
          Promise.all(promises).then()
        );
      },
      invalidatesTags: ['settings-data'],
    }),
  }),
});
